export const SOLUTION_SECTIONS: Record<string, { index: number; tabs: string[] }> = {
  "actual-intelligence": { index: 1, tabs: ["1.0", "1.1", "1.2"] },
  "automation-labs": { index: 2, tabs: ["2.0", "2.1", "2.2"] },
  "system-bridge": { index: 3, tabs: ["3.0", "3.1", "3.2"] },
  "outage-hub": { index: 4, tabs: ["4.0", "4.1", "4.2"] },
  "tech-mentor": { index: 5, tabs: ["5.0", "5.1", "5.2"] },
  "troubleshooting": { index: 6, tabs: ["6.0", "6.1", "6.2"] },
  "client-intelligence": { index: 7, tabs: ["7.0", "7.1"] },
  "vendor-ops": { index: 8, tabs: ["8.0", "8.1"] },
  "lifecycle-navigator": { index: 9, tabs: ["9.0", "9.1"] },
  "project-execution": { index: 10, tabs: ["10.0", "10.1", "10.2"] },
  "onboarding": { index: 11, tabs: ["11.0", "11.1", "11.2"] },
};

export const DESKTOP_TAB_SECTIONS: string[] = ["1.0", "2.0", "3.0", "4.0", "5.0", "6.0"];

export const DESKTOP_REDESIGN_SECTIONS: string[] = ["3.1", "3.2", "3.3", "3.4", "3.5", "3.6"];

export const TOTAL_SOLUTIONS_SECTIONS = Object.values(SOLUTION_SECTIONS).reduce(
  (sum, s) => sum + s.tabs.length,
  0
);

export const TOTAL_DESKTOP_SECTIONS =
  DESKTOP_TAB_SECTIONS.length + DESKTOP_REDESIGN_SECTIONS.length;
